// extracted by mini-css-extract-plugin
module.exports = {"BaseLayout":"BaseLayout_BaseLayout___VUEC","BaseLayout__Footer":"BaseLayout_BaseLayout__Footer__QRbnC"};